import React from 'react';
import { MONTH_NAMES, MONTH_OPTIONS, yearOptions } from './period';

interface ReportPeriodSelectorProps {
    year: number;
    month: number;
    onYearChange: (year: number) => void;
    onMonthChange: (month: number) => void;
}

/**
 * The month being settled. Shared by every city's report card so the monthly
 * close is picked once rather than per municipality.
 */
const ReportPeriodSelector: React.FC<ReportPeriodSelectorProps> = ({
    year,
    month,
    onYearChange,
    onMonthChange
}) => (
    <div className="bg-white border rounded-lg p-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Report period</h2>
        <p className="text-sm text-gray-600 mb-4">
            Settling {MONTH_NAMES[month - 1]} {year}.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="report-year">
                    Year
                </label>
                <select
                    id="report-year"
                    value={year}
                    onChange={(e) => onYearChange(parseInt(e.target.value))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                >
                    {yearOptions().map(y => (
                        <option key={y} value={y}>{y}</option>
                    ))}
                </select>
            </div>
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="report-month">
                    Month
                </label>
                <select
                    id="report-month"
                    value={month}
                    onChange={(e) => onMonthChange(parseInt(e.target.value))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                >
                    {MONTH_OPTIONS.map(m => (
                        <option key={m} value={m}>{MONTH_NAMES[m - 1]}</option>
                    ))}
                </select>
            </div>
        </div>
    </div>
);

export default ReportPeriodSelector;
